module.exports = __webpack_public_path__ + "img/puma-shoes.c8723596.jpeg";